import { z } from "zod"

import { zodFallback } from "~/lib/zod/utils/zod-fallback"

export function sbText() {
  return z.string().or(zodFallback(null))
}
